<ng-template #content let-modal>
    <div class="modal-header" style="justify-content: center">
        <h1>Contact us</h1>
    </div>
    <form ngNoForm [action]="'https://formspree.io/f/mrgjnjgz'" method="POST" style="text-align: center;">
        <div class="modal-body">
            <div>
                <br/>
                <label style="font-size: large; background-color: #2A4152; text-align: left; padding: 1rem; border-radius: 10px; width: 68%">
                    <span style="color: white;">Email Address:</span><br/>
                    <input type="email" name="email" style="border: 0; width: -webkit-fill-available">
                </label>
                <br/><br/>
                <label style="font-size: large; background-color: #2A4152; text-align: left; padding: 1rem; border-radius: 10px;">
                    <span style="color: white;">Message</span> <br/>
                    <textarea name="message" rows="6" cols="35" style="border: 0"></textarea>
                </label>
            </div>
            <!-- your other form fields go here -->
        </div>
        <div class="modal-footer" style="justify-content: center">
            <div class="subOrClose">
                <div class="row">
                    <div class="col">
                        <button type="submit" class="btn" style="border-radius: 10px; font-size: small; background-color: #5ECE42; color: white;">Send</button>
                    </div>
                </div><br />
                <div class="row">
                    <div class="col">
                        <button type="button" class="btn btn-danger" (click)="modal.close('Close')" style="border-radius: 10px; font-size: small">Close</button>
                    </div>
                </div>

            </div>
        </div>
    </form>
    <br />
</ng-template>

<button class="btn btn--transparent mobilePos theBtn" style="color: white; font-weight: bold; font-size: medium;  background-color: #5ECE42;
border-radius: 0.4rem;  border: 0.2rem solid #5ECE42; border-color: #898FB5;
    background-color: transparent;" (click)="open(content)">Contact Us</button>


<!-- modify this form HTML and place wherever you want your form -->